module.exports = __webpack_public_path__ + "assets/delivery-a64f94.svg";